<template>
	<div id="feature-availability-warning-dialog" class="warning banner" style="display: none;">
		<strong>The following features of this form are not available on your current plan:</strong>
		<ul id="feature-not-available-list"></ul>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';

	export default defineComponent({});
</script>
